<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
  >
    <path d="M6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0ZM8.12028 4.16398L5.24953 7.04242L3.85355 5.64645C3.65829 5.45118 3.34171 5.45118 3.14645 5.64645C2.95118 5.84171 2.95118 6.15829 3.14645 6.35355L4.89645 8.10355C5.09189 8.299 5.40884 8.29879 5.60403 8.10308L8.82833 4.87014C9.02333 4.67462 9.02291 4.35804 8.82738 4.16304C8.63186 3.96803 8.31528 3.96846 8.12028 4.16398Z" />
  </svg>
</template>